import React from 'react';

const features = [
  {
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#70d8ff" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>,
    title: 'AI智能规划',
    desc: '像老朋友一样懂你的旅行偏好。告诉我你想去哪里,30秒生成连你没想到的惊喜行程。',
    cta: '立即规划 →',
    ctaColor: 'cg',
    image: 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=600&q=65',
    fallback: 'linear-gradient(135deg, #1a3a5c 0%, #0d2240 100%)',
  },
  {
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ffc857" strokeWidth="1.5"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>,
    title: '温暖日记记录',
    desc: '不只是记录,是和未来的自己对话。每篇日记都是一封写给未来的信。',
    cta: '开始写→',
    ctaColor: 'ca',
    image: 'https://images.unsplash.com/photo-1517842645767-c639042777db?w=600&q=65',
    fallback: 'linear-gradient(135deg, #3d2e1a 0%, #2a1f0f 100%)',
  },
  {
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#9ec8e0" strokeWidth="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
    title: '灵感目的地',
    desc: '500+精选目的地,每个推荐都来自真实旅人的足迹。总有一处让你心动。',
    cta: '去探索 →',
    ctaColor: 'cm',
    image: 'https://images.unsplash.com/photo-1506929562872-bb421503ef21?w=600&q=65',
    fallback: 'linear-gradient(135deg, #0f3a4a 0%, #082231 100%)',
  },
  {
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#70d8ff" strokeWidth="1.5"><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/><path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/></svg>,
    title: '深度旅行攻略',
    desc: '去过的人才知道的好,才是真的好。每篇攻略都由资深旅人和AI联手打磨。',
    cta: '去看看 →',
    ctaColor: 'cg',
    image: 'https://images.unsplash.com/photo-1527631746610-bca00a040d60?w=600&q=65',
    fallback: 'linear-gradient(135deg, #1a3a5c 0%, #0d2240 100%)',
  },
  {
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#9ec8e0" strokeWidth="1.5"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>,
    title: '治愈旅行社区',
    desc: '在路上,你从不孤单。找到志同道合的旅友,交换旅途故事。',
    cta: '加入 →',
    ctaColor: 'cm',
    image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=600&q=65',
    fallback: 'linear-gradient(135deg, #0f3a4a 0%, #082231 100%)',
  },
  {
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ffc857" strokeWidth="1.5"><circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/></svg>,
    title: '积分探险家',
    desc: '每一次认真的旅行,都值得被奖励。写日记、发游记都能攒积分。',
    cta: '查看 →',
    ctaColor: 'ca',
    image: 'https://images.unsplash.com/photo-1551632811-561732d1e306?w=600&q=65',
    fallback: 'linear-gradient(135deg, #3d2e1a 0%, #2a1f0f 100%)',
  },
];

const FeaturesSection = () => {
  const [imgErrors, setImgErrors] = React.useState({});

  return (
    <section id="feat" className="py-24">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16" style={{ animation: 'rise .75s ease-out both' }}>
          <div className="text-[11px] tracking-[0.25em] mb-4 cm">FEATURES ·核心特色</div>
          <h2 className="text-3xl md:text-4xl font-bold mb-3 cb is">西蒙的猫</h2>
          <p className="text-sm cm max-w-sm mx-auto">愿你的每个旅程都被温柔以待</p>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {features.map((f, i) => (
            <div
              key={i}
              className="group relative overflow-hidden rounded-2xl border border-[rgba(156,200,224,0.12)] transition-all duration-500 hover:-translate-y-1 hover:border-[rgba(130,220,255,0.25)] hover:shadow-[0_18px_56px_rgba(0,0,0,0.4)]"
              style={{ animation: `rise .75s ease-out ${i * 0.08}s both`, minHeight: '280px' }}
            >
              {/* 背景图片 */}
              <div className="absolute inset-0">
                {!imgErrors[i] ? (
                  <img
                    src={f.image}
                    alt={f.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    loading="lazy"
                    onError={() => setImgErrors(prev => ({ ...prev, [i]: true }))}
                    style={{ filter: 'saturate(0.7) brightness(0.6)' }}
                  />
                ) : (
                  <div className="w-full h-full" style={{ background: f.fallback }} />
                )}
                {/* 渐变遮罩 - 确保文字可读 */}
                <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(6,19,38,0.45) 0%, rgba(6,19,38,0.7) 50%, rgba(6,19,38,0.92) 100%)' }} />
                {/* 边缘青色光晕 */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ boxShadow: 'inset 0 0 60px rgba(112,216,255,0.08)' }} />
              </div>

              {/* 内容 */}
              <div className="relative z-10 p-7 flex flex-col justify-end h-full" style={{ minHeight: '280px' }}>
                <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5 backdrop-blur-md" style={{ background: 'rgba(16,41,77,0.6)', border: '1px solid rgba(130,220,255,0.18)' }}>
                  {f.icon}
                </div>
                <h3 className="text-base font-semibold mb-2 cb drop-shadow-lg">{f.title}</h3>
                <p className="text-[13px] cm leading-relaxed drop-shadow-md">{f.desc}</p>
                <a href="#" className={`inline-block mt-4 text-[13px] ${f.ctaColor} hover:underline drop-shadow-md`}>{f.cta}</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
